import Api from '../../api/Api'

const reseller = {
  namespaced: true,
  state: {
    transaksi_reseller: [],
    transaksi_reseller2: [],
    customer_reseller: [],
    batch: [],
    info_reseller: {},
    empty: '',
    penarikanSaldo: {
      header: [
        { text: 'ID Transaksi', value: 'id', width: 160, sortable: true },
        { text: 'Jumlah', value: 'amount', width: 200 },
        { text: 'Terima Bersih', value: 'total', width: 200 },
        { text: 'Tanggal Request', value: 'date', width: 200 },
        { text: 'Status', value: 'status', width: 200 },
      ],
      list: [],
      isLoading: false,
    },
    transaksi: {
      header: [
        { text: 'Nama', value: 'name', width: 210, sortable: true },
        { text: 'Nomor Telepon', value: 'phone', width: 200 },
        { text: 'Link pembayaran', value: 'link_pembayaran', width: 200 },
        { text: 'Status', value: 'status', width: 200 },
        { text: 'Nama Produk', value: 'product', width: 200 },
        { text: 'Tipe Produk', value: 'type', width: 200 },
        { text: 'Batch', value: 'batch', width: 200 },
        { text: 'Untuk Pembayaran', value: 'purpose', width: 200 },
        { text: 'Tanggal', value: 'date', width: 200 },
        { text: 'Invoice', value: 'invoice', width: 210, sortable: true },
        { text: 'Kode Kupon', value: 'coupon', width: 200 },
        { text: 'Potongan Kupon', value: 'admin', width: 200 },
        { text: 'Metode', value: 'method', width: 200 },
        { text: 'Fee Channel', value: 'fee_channel', width: 200 },
        { text: 'Fee Reseller', value: 'fee_reseller', width: 200 },
        { text: 'Action', value: 'action', width: 200 },
      ],
      list: [],
      isLoading: false,
    },
  },
  mutations: {
    SET_TRANSAKSI_RESELLER(state, data) {
      state.transaksi_reseller = data
      state.transaksi_reseller2 = data
    },
    SET_TRANSAKSI(state, data) {
      state.transaksi.list = data
    },
    SET_PENARIKAN_SALDO(state, data) {
      state.penarikanSaldo.list = data
    },
    SET_INFO_RESELLER(state, data) {
      state.info_reseller = data
    },
    SET_CUSTOMER_RESELLER(state, data) {
      var temp = []
      data.forEach((el) => {
        let data = {
          name: el.fullname,
          email: el.email,
          telp: el.telepone,
          status: el.status_transaksi,
          link: 'https://app.midtrans.com/snap/v2/vtweb/' + el.snap_token,
          produk: el.judul,
          tanggal: el.created_at,
          kode_kupon: el.kode_kupon,
          metode: el.bank_transfer
            ? el.bank_transfer
            : 'belum melakukan pembayaran',
          fee_channel: el.fee_channel,
          id_status_transaksi: el.id_status_transaksi,
          jenis_produk: el.id_jenis,
        }
        temp.push(data)
      })

      state.customer_reseller = temp
    },
    SET_BATCH(state, batch) {
      state.batch = batch
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },
  actions: {
    listProduk({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/reseller/produk?page=${data.page}&per_page=${data.per_page}&search=${data.search}&event=${data.event}&level=${data.level}&tags=${data.tags}&status=${data.status}&jenis_produk=${data.jenis_produk}&start=${data.start}&end=${data.end}`,
        )
          // Api.get(`/reseller/produk?page=${data.page}&event=${data.event}&search=${data.search}&tags=${data.tags}&level=${data.level}`)
          .then((response) => {
            commit('SET_TRANSAKSI_RESELLER', response.data.data.data)
            commit('SET_INFO_RESELLER', response.data.info)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    profile() {
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/profile`)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detailReseller({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/reseller/detailReseller/${data.id}?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}&status_transaksi=${data.status_transaksi}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            commit('SET_CUSTOMER_RESELLER', response.data.customer.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addWd({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/ajukan_wd`, data)
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahSetting({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/ubahSetting`, data)
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateDFeeReseller({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/updateDFeeReseller`, data)
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    async gethistorywd({ commit, state }, params) {
      state.penarikanSaldo.isLoading = true

      try {
        const response = await Api.get(
          `/reseller/history-wd?page=${params.page}&per_page=${params.per_page}&search=${params.search}&status=${params.status}&start=${params.start}&end=${params.end}`,
        )
        commit('SET_PENARIKAN_SALDO', response.data.data.data)
        return response.data.data
      } catch (error) {
        throw error
      } finally {
        state.penarikanSaldo.isLoading = false
      }
    },
    payment({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/reseller/payment?status=${data.status}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    dashboard() {
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/dashboard`)
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDetailStatusPesentaseReseller({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/getDetailStatusPesentaseReseller?id=${data.id}`)
          .then((response) => {
            commit('')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    incrementView({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/incrementView?id_event=${data.id_event}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    saveGrup({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/saveGrup`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    infoPaymentAdmin() {
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/infoPaymentAdmin`)
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    exportPayment() {
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/ExportWD`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_history({ commit }, params) {
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/ExportHistoryWDAdmin?selected=${params.selected}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_payment({ commit }, params) {
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/ExportPaymentWDAdmin?selected=${params.selected}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    async transaksi({ commit, state }, data) {
      state.transaksi.isLoading = true

      try {
        const response = await Api.get(
          `/reseller/transaksi?status=${data.status}&start=${data.start}&end=${data.end}&id=${data.id}&id_role=${data.id_role}&id_batch=${data.id_batch}&page=${data.page}&search=${data.search}`,
        )
        commit('SET_BATCH', response.data.batch)
        commit('SET_EMPTY', '')
        commit('SET_TRANSAKSI', response.data.data.data)

        return response.data.data
      } catch (error) {
        throw error
      } finally {
        state.transaksi.isLoading = false
      }
    },
    async exportTransaksi({ state }) {
      state.transaksi.isLoading = true
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'

      try {
        const response = await Api.get(`/reseller/transaksiResellerExport`)
        return response
      } catch (error) {
        throw error
      } finally {
        state.transaksi.isLoading = false
      }
    },
    detailProduk({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/produk-detail/${data.id}?id_batch=${data.id_batch}&page=${data.page || 1}&per_page=${data.per_page || 10}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addReseller({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/add-reseller`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahprofile({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/ubah-profile`, data)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahRekening({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/add-rekening`, data)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    actived({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/actived/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deactived({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/deactived/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export({ commit }, data) {
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'
      return new Promise((resolve, reject) => {
        Api.get(`/reseller/export`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleted({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/deleted/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listReseller({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/reseller/list_reseller?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listApproval({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/reseller/listApproval?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}&role=${data.role}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listHistoryAdmin({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/reseller/historyApprovalAdmin?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}&role=${data.role}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    approved({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/approvePengajuan/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    reject({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/reseller/rejectPengajuan/${data.id}`, data)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  getters: {
    getTransaksiReseller(state) {
      return state.transaksi_reseller
    },
    getTransaksiReseller2(state) {
      return state.transaksi_reseller2
    },
    getInfoReseller(state) {
      return state.info_reseller
    },
    getCustomerReseller(state) {
      return state.customer_reseller
    },
    getBatch(state) {
      return state.batch
    },
    getTransaksi(state) {
      return state.transaksi.list
    },
    getHistoryPenarikanSaldo(state) {
      return state.penarikanSaldo.list
    },
  },
}

export default reseller
